/**
 * Planuri SpressJoy și accesul la funcții. Ținut identic cu functions/lib/plans.js.
 * Fără plan setat (conturi vechi / perioada de probă) = acces la tot.
 */
export const FEATURES = {
  statsAdvanced: 'Statistici avansate (interval, pe luni, ore, PDF)',
  loyalty: 'Fidelizare cu ștampile',
  events: 'Modul Eveniment',
  joyAi: 'Joy AI (asistent și afișe)',
  ranking: 'Clasamentul clienților (top 3)',
  campaignGuaranteed: 'Campanie instant (fără notar)',
  campaignScratch: 'Răzuiește și câștigă (bilete stabilite dinainte, cu bon)',
  campaignLottery: 'Campanii la noroc și tombole (cu notar)'
};

export const PLANS = {
  start: { label: 'START', price: 49, features: [] },
  smart: { label: 'SMART', price: 99, features: ['statsAdvanced', 'loyalty', 'events', 'joyAi', 'campaignGuaranteed'] },
  pro: { label: 'PRO', price: 199, features: ['statsAdvanced', 'loyalty', 'events', 'joyAi', 'campaignGuaranteed', 'ranking', 'campaignScratch'] },
  custom: { label: 'CUSTOM', price: null, features: Object.keys(FEATURES) }
};

export function minPlanFor(feature) {
  return ['start', 'smart', 'pro', 'custom'].find((p) => PLANS[p].features.includes(feature)) || 'custom';
}

export function featuresFor(settings = {}) {
  const tier = PLANS[settings?.planTier] ? settings.planTier : null;
  const base = new Set(tier ? PLANS[tier].features : Object.keys(FEATURES));
  const ov = settings?.featureOverrides && typeof settings.featureOverrides === 'object' ? settings.featureOverrides : {};
  Object.keys(FEATURES).forEach((k) => {
    if (ov[k] === true) base.add(k);
    if (ov[k] === false) base.delete(k);
  });
  return base;
}

export function hasFeature(settings, feature) {
  return featuresFor(settings).has(feature);
}

export function featureLockedMessage(feature) {
  const p = PLANS[minPlanFor(feature)];
  return `Funcția „${FEATURES[feature] || feature}” e disponibilă în planul ${p.label}. Scrie-ne ca să-ți activăm planul.`;
}

/** Verificare în UI: dacă planul nu include funcția, arată mesajul și întoarce false. */
export async function ensureFeature(feature) {
  try {
    const { getCurrentSettings } = await import('../services/settings.js?v=83.21');
    if (hasFeature(getCurrentSettings() || {}, feature)) return true;
    const { showSnackbar } = await import('../utils/ui.js?v=83.21');
    showSnackbar(`🔒 ${featureLockedMessage(feature)}`, 'info');
    return false;
  } catch (_) {
    return true;
  }
}

/** Ca ensureFeature, dar e suficientă oricare dintre funcții. */
export async function ensureAnyFeature(features = []) {
  try {
    const { getCurrentSettings } = await import('../services/settings.js?v=83.21');
    const st = getCurrentSettings() || {};
    if (features.some((f) => hasFeature(st, f))) return true;
    const { showSnackbar } = await import('../utils/ui.js?v=83.21');
    showSnackbar(`🔒 ${featureLockedMessage(features[0])}`, 'info');
    return false;
  } catch (_) {
    return true;
  }
}
